import { Button, StyledText } from "../../../../components/common";
import { BackIcon, CloseIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SpinTheWheelModal = ({
  onBackDropClick,
  headerText,
  emoji,
  mainText,
  buttonText,
  onButtonClick,
}) => {
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  return (
    <>
      <div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            top: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
          onClick={onBackDropClick}
        ></div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            width: "100%",
            bottom: 0,
          }}
        >
          <div
            style={{
              boxSizing: "border-box",
              padding: "20px",
              height: "60%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "white",
              marginTop: "70%",
              borderTopRightRadius: 15,
              borderTopLeftRadius: 15,
            }}
          >
            <div
              style={{
                width: 50,
                height: 8,
                backgroundColor: "#cbcbcb",
                borderRadius: 10,
              }}
            />
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                marginTop: 5,
                marginBottom: 5,
              }}
            >
              <div onClick={onBackDropClick}>
                <BackIcon fill="transparent" />
              </div>
              <div onClick={onBackDropClick}>
                <CloseIcon fill="black" />
              </div>
            </div>

            <StyledText style={{ fontSize: 20 }}>{headerText}</StyledText>

            <StyledText style={{ fontSize: 40, margin: 0 }}>{emoji}</StyledText>

            <StyledText
              style={{
                textAlign: "center",
                fontFamily: "MTNRegular",
                paddingInline: 15,
              }}
            >
              {mainText}
            </StyledText>
            <Button
              style={{ backgroundColor: background, width: "80%" }}
              onClick={onButtonClick}
            >
              <StyledText color="white">{buttonText}</StyledText>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpinTheWheelModal;
